import { render, staticRenderFns } from "./DadosConsultor.vue?vue&type=template&id=210be628"
import script from "./DadosConsultor.vue?vue&type=script&lang=ts"
export * from "./DadosConsultor.vue?vue&type=script&lang=ts"
import style0 from "./DadosConsultor.vue?vue&type=style&index=0&id=210be628&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports